















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TuandcoImageMenu extends Vue {

  get links(): string[] {
    return [
      'https://www.tuandco.com/bano',
      'https://www.tuandco.com/jardin',
      'https://www.tuandco.com/piscina',
      'https://www.tuandco.com/calefaccion-climatizacion',
      'https://www.tuandco.com/fontaneria',
      'https://www.tuandco.com/ferreteria-online',
      'https://www.tuandco.com/cocina',
      'https://www.tuandco.com/iluminacion',
      'https://www.tuandco.com/electricidad'
    ];
  }

  get images(): string[] {
    return [
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/ban_o2_1.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/jardin_2.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/piscina_2.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/calefaccion_1.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/fontaneria_1.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/ferreteria_2.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/cocina_1.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/iluminacion_2.jpg',
      'https://tuandco.a.ssl.fastly.net/media/catalog/category/electricidad_3.jpg'
    ];
  }

  get text(): string[] {
    return ['baño', 'jardinería', 'piscinas', 'calefacción', 'fontanería', 'ferretería', 'cocina', 'iluminación', 'electricidad'];
  }
}
